import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { request } from '../http/index';
import config from '../config';
import { REFRESH_URL } from '../constants/login';
export function getLoginUrls() {
  return ['/verifier/api/sms', '/metis-atlas-account/api/auth/phone-login', '/metis-atlas-account/api/auth/phone-password-login', '/metis-atlas-account/api/auth/logout', '/metis-atlas-account/api/account/password/reset', REFRESH_URL.AUTH, REFRESH_URL.INSTITUTION, REFRESH_URL.STUDENT, REFRESH_URL.TENANT, '/metis-atlas-account/api/auth/designation-login', '/metis-atlas-account/api/student-auth/designation-login', '/metis-atlas-account/api/open-auth/open-login', '/metis-atlas-account/api/open-auth/app-biz/open-login', '/metis-weixin/api/ws/bind', "/metis-weixin/api/ws/".concat(config.WX_SCAN_APPID, "/oauth-atlas-callback"), '/metis-weixin/api/ws/login', '/metis-weixin/api/ws/bind-v2', '/metis-weixin/api/ws/profile-bind', '/metis-atlas-account/api/student-auth/phone-login', '/metis-atlas-account/api/student-auth/phone-password-login', '/metis-atlas-account/api/institutional-auth/phone-login', '/metis-atlas-account/api/institutional-auth/phone-password-login', '/metis-flying/api/external/auth/login', '/metis-weixin/api/mp/login', '/metis-weixin/api/mp/bind'];
}
export function sendVerifyCode(params) {
  params.UDID = params.UDID || 'C37798E9-7067-43AF-BCDA-6D8DC0984E71';
  params._productId = params._productId || '2131';
  params.version = params.version || '1.0.0';
  return request({
    url: '/verifier/api/sms',
    method: 'POST',
    params: params
  });
}
export function verifyCodeLogin(params) {
  return request({
    url: '/metis-atlas-account/api/auth/phone-login',
    method: 'POST',
    params: params,
    customErr: true
  });
}
export function refreshCodeToken(params) {
  var c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var url = params.url;
  delete params.url;
  return request(_objectSpread({
    // url: '/metis-atlas-account/api/auth/refresh',
    url: url,
    method: 'POST',
    params: params,
    customErr: true
  }, c));
}
export function phonePasswordLogin(params) {
  return request({
    url: '/metis-atlas-account/api/auth/phone-password-login',
    method: 'POST',
    params: params,
    customErr: true
  });
}
export function flyingLogin(params) {
  var username = params.phone;
  delete params.phone;
  return request({
    url: '/metis-flying/api/external/auth/login',
    method: 'POST',
    params: _objectSpread(_objectSpread({}, params), {}, {
      username: username
    }),
    customErr: true
  });
}
export function getUserTenants() {
  return request({
    url: '/metis-atlas-account/api/select-tenant-auth/tenants',
    method: 'GET',
    customErr: true
  });
}
export function getUserTenantsIns() {
  return request({
    url: '/metis-atlas-membership/api/login/support/teacher/option',
    method: 'GET',
    customErr: true
  });
}
export function getUserTenantsOfficeIns() {
  return request({
    url: '/metis-atlas-membership/api/login/support/office/option',
    method: 'GET',
    customErr: true
  });
}
/**
 * 这个不是真实接口，是为了满足判断代码虚构出来的
 * @returns
 */
export function getUserTenantsFlying() {
  return new Promise(function (resolve) {
    // @ts-ignore
    resolve({
      data: {
        code: '0',
        message: '',
        result: [{
          // 老的字段兼容
          name: '',
          tenantId: 1,
          // 新字段
          institutionName: '',
          institutionId: 1,
          // 是否是机构版
          inInstitution: true
        }]
      }
    });
  });
}
export function logOutService() {
  return request({
    url: '/metis-atlas-account/api/auth/logout',
    method: 'POST',
    params: {
      userAgent: 'web'
    },
    customErr: true
  });
}
export function resetPassWord(params) {
  return request({
    url: '/metis-atlas-account/api/account/password/reset',
    method: 'POST',
    params: params,
    customErr: true
  });
}
export function updatePhone(params) {
  return request({
    url: '/metis-atlas-account/api/account/replcae-phone',
    method: 'POST',
    params: params,
    customErr: true
  });
}
export function getCurrentAccount() {
  return request({
    url: '/metis-atlas-account/api/account/current',
    method: 'GET',
    customErr: true
  });
}
export function updateCurrentAccount(data, _productId) {
  return request({
    url: '/metis-atlas-account/api/account/current',
    method: 'PUT',
    data: data,
    params: {
      _productId: _productId
    },
    customErr: true
  });
}
export function getCurrentStudentAccount() {
  return request({
    url: '/metis-atlas-account/api/account/current/selected-student',
    method: 'GET',
    customErr: true
  });
}
// eslint-disable-next-line camelcase
export function updateCurrentStudentAccount(data, _selected_student_, _productId) {
  return request({
    url: '/metis-atlas-account/api/account/current/selected-student',
    method: 'PUT',
    data: data,
    params: {
      // eslint-disable-next-line camelcase
      _selected_student_: _selected_student_,
      _productId: _productId
    },
    customErr: true
  });
}
export function designationLogin(designationCode) {
  return request({
    url: '/metis-atlas-account/api/auth/designation-login',
    method: 'POST',
    params: {
      designationCode: designationCode
    }
  });
}
export function designationStudentLogin(designationCode) {
  return request({
    url: '/metis-atlas-account/api/student-auth/designation-login',
    method: 'POST',
    params: {
      designationCode: designationCode
    }
  });
}
export function openLogin(code) {
  return request({
    url: '/metis-atlas-account/api/open-auth/open-login',
    method: 'POST',
    params: {
      code: code
    }
  });
}
// 第三方账号免密登录 https://mapi.feixiangxingqiu.biz/metis-atlas-account/api/swagger/doc.html#/default/%E5%BC%80%E6%94%BE%E8%AE%A4%E8%AF%81/appBizOpenLoginUsingPOST
export function openLoginV2(code) {
  return request({
    url: '/metis-atlas-account/api/open-auth/app-biz/open-login',
    method: 'POST',
    params: {
      code: code
    }
  });
}
export function wxScanBindPhone(params) {
  return request({
    url: '/metis-weixin/api/ws/bind',
    method: 'POST',
    params: params
  });
}
export function unBindWx() {
  return request({
    url: '/metis-weixin/api/users/unbind',
    method: 'GET',
    customErr: true
  });
}
/**
 * 登录页扫码登录，有两种结果：
 *
 * 1. 微信已经绑定了飞象账号，直接扫码登录成功，
 *
 * 2. 微信没有绑定飞象账号，返回微信信息，为了后续进行手动绑定
 */
export function wxOauthLogin(data) {
  return request({
    url: '/metis-weixin/api/ws/login',
    method: 'POST',
    customErr: true,
    data: data
  });
}
/**
 * 登录页扫码登录后，未绑定飞象账号，第二步输入手机号+验证码绑定账号并登录
 */
export function wxOauthBindMetis(data) {
  return request({
    url: '/metis-weixin/api/ws/bind-v2',
    method: 'POST',
    customErr: true,
    data: data
  });
}
/**
 * 已登录状态、个人信息页扫码绑定微信
 */
export function wxOauthBindWx(data) {
  return request({
    url: '/metis-weixin/api/ws/profile-bind',
    method: 'POST',
    customErr: true,
    data: data
  });
}
/**
 * 解锁学生账号 | 当前机构
 */
export function unlockStudentAccount(data) {
  return request({
    url: '/metis-atlas-membership/api/student/unlock-student-account/in-institution',
    method: 'POST',
    data: data
  });
}